import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from "redux-thunk";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './userReducer';
import orgReducer from './organization/orgReducer';
import tokenReducer from './token/tokenReducer';
import projectReducer from './project/projectReducer';
import activeUserReducer from './activeUser/activeUserReducer';
import fileStorageReducer from './fileStorage/fileStorageReducer';
import kaiziqResolveReducer from './kaiziqResolve/kaiziqResolveReducer';
import cacheReducer from './cacheReducer';
import subscriptionReducer from './subscription/subscriptionReducer';
import billingUsageReducer from './billingUsage/billingUsageReducer';

const combine = combineReducers({
  user: userReducer,
  org: orgReducer,
  project: projectReducer,
  activeUser: activeUserReducer,
  fileStorage: fileStorageReducer,
  resolve: kaiziqResolveReducer,
  token: tokenReducer,
  cache: cacheReducer,
  subscription: subscriptionReducer,
  billingUsage: billingUsageReducer
});

const persistConfig = {
  key: 'root',
  storage,
};

const rootReducer = (state, action)=> {
    if(action.type === 'RESET') {
        return combine(undefined, action);
    }
    return combine(state, action);
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

export { store, persistor };